import routes from '../../router/routes';

const config = [
  // { title: 'Overview', route: routes.OVERVIEW },
  { title: 'Contents', route: routes.CONTENTS },
  { title: 'Add Contents', route: routes.ADD_CONTENTS },
  { title: 'Send Notification', route: routes.SEND_NOTIFICATION },
  // { title: 'Price', route: routes.PRICE }
];

export default config;
